import React, { ReactNode } from 'react';
import { t } from 'i18next';
import {
  getSellingPortfolio,
  getUserFullName,
  isSingleElementArray,
} from 'utils';
import { getFormattedDate, DATE_FORMAT_SHORT_SLASH_WITH_TIME } from 'dateUtils';
import {
  TableHeaderKey,
  BossModeTrack,
  BOSS_MODE_TRACK_EVENTS_LABEL,
  BOSS_MODE_TRACK_EVENTS_COLOR,
} from '../../types';
import ArrayPopup from 'components/ArrayPopup';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { AvatarWithInitials } from 'components/AvatarWithInitials';
import ArrowrightIcon from 'icons/Arrowright.icon';
import NdaStatusBadge from '../../../../../Messaging/components/NdaSigningProgress/NdaStatusBadge';
import { NEW_WINDOW_PROPS } from 'data/global';
import { LEAD_DRAWER_OPTIONS } from 'router/subrouters/Dash/subrouters/private/subrouters/Portfolio/subrouters/Seller/models';

export const UserCell: React.FC<BossModeTrack> = (props) => {
  const { user } = props;

  const { firstName, lastName } = user || {};

  return (
    <div className="name-cell">
      <AvatarWithInitials user={user} />
      <p>{getUserFullName(firstName, lastName)}</p>
    </div>
  );
};

export const NdaStatusCell: React.FC<BossModeTrack> = (props) => {
  const { previousNdaStatus, newNdaStatus, envelopeTemplateName } = props;

  if (!previousNdaStatus && !newNdaStatus)
    return <div className="nda-status-cell">/</div>;

  return (
    <div className="nda-status-cell">
      {previousNdaStatus && (
        <NdaStatusBadge
          status={previousNdaStatus}
          envelopeTemplateName={t('nda')}
          envelopeTemplatePopupName={envelopeTemplateName}
        />
      )}

      {previousNdaStatus && newNdaStatus && <ArrowrightIcon />}

      {newNdaStatus && (
        <NdaStatusBadge
          status={newNdaStatus}
          envelopeTemplateName={t('nda')}
          envelopeTemplatePopupName={envelopeTemplateName}
        />
      )}
    </div>
  );
};

export const BODY_CONTENT_GENERATE: Partial<
  Record<TableHeaderKey, (event: BossModeTrack) => ReactNode>
> = {
  eventType: ({ eventType }: BossModeTrack) => (
    <div>
      <span
        className={classNames(
          'event-pills',
          BOSS_MODE_TRACK_EVENTS_COLOR[eventType],
        )}
      >
        {t(BOSS_MODE_TRACK_EVENTS_LABEL[eventType])}
      </span>
    </div>
  ),
  user: (cellProps: BossModeTrack) => <UserCell {...cellProps} />,
  dealRoomNames: ({ dealRoomNames, dealRoomIds }: BossModeTrack) =>
    isSingleElementArray(dealRoomNames) ? (
      <Link
        className="as-link-black"
        to={getSellingPortfolio(dealRoomIds[0])}
        {...NEW_WINDOW_PROPS}
      >
        {dealRoomNames[0]}
      </Link>
    ) : (
      <ArrayPopup
        list={dealRoomNames}
        popupText="numberDeals"
        emptyPlaceholder="/"
      />
    ),
  leadNames: ({ leadNames, leadIds, dealRoomIds }: BossModeTrack) =>
    isSingleElementArray(leadNames) ? (
      <Link
        className="as-link-black"
        to={`${getSellingPortfolio(dealRoomIds[0], 'leads')}?leadId=${
          leadIds[0]
        }&open=${LEAD_DRAWER_OPTIONS.PROFILE}`}
        {...NEW_WINDOW_PROPS}
      >
        {leadNames[0]}
      </Link>
    ) : (
      <ArrayPopup
        list={leadNames}
        popupText="numberOfLeads"
        emptyPlaceholder="/"
      />
    ),
  previousNdaStatus: (cellProps: BossModeTrack) => (
    <NdaStatusCell {...cellProps} />
  ),
  createdAt: ({ lastEventAt, createdAt }: BossModeTrack) => (
    <div>
      {getFormattedDate(
        lastEventAt || createdAt,
        DATE_FORMAT_SHORT_SLASH_WITH_TIME,
      )}
    </div>
  ),
};
